import * as API from '../_api';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import {Cluster, Vector as VectorSource} from 'ol/source';
import {Vector as VectorLayer} from 'ol/layer';
import {Fill, Stroke, Style, Text} from 'ol/style';

// @ts-ignore
export const read = async ({commit, dispatch}) => {
  try {
    const all = await API.read();
    commit('setLayers', all.data);
    return true;
  } catch (ex) {
    dispatch('common/snackbar/error', ex, {root: true});
    return false;
  }
};

// @ts-ignore
export const init = async ({state, dispatch}) => {
  // check if pharmacies are cached
  if (!state.pharmacies) {
    const ret = await API.read();
    state.pharmacies = ret.data.features;

    // @ts-ignore
    const features = new Array(state.pharmacies.length);
    // @ts-ignore
    for (let i = 0; i < state.pharmacies.length; ++i) {
      // @ts-ignore
      const coordinates: [number, number] = state.pharmacies[i].geometry.coordinates;
      features[i] = new Feature(new Point(coordinates));
      // @ts-ignore
      features[i].setProperties(state.pharmacies[i].properties);
    }

    const featuresVectorSource = new VectorSource({
      features,
    });

    const featuresClusterSource = new Cluster({
      distance: 40,
      source: featuresVectorSource,
    });

    // @ts-ignore
    state.pharmaciesVectorLayer = new VectorLayer({
      source: featuresClusterSource,
      style: (feature: any) => {
        const size = 1;
        if (size > 1 && state.styleCachePharmacy[size]) {
          return state.styleCachePharmacy[size];
        }

        const params = {
          text: new Text({
            font: 'bold ' + 16 + 'px "Open Sans", "Arial Unicode MS", "sans-serif"',
            text: 'A',
            fill: new Fill({
              color: '#F60200',
            }),
            stroke: new Stroke({
              color: '#AE0B0B',
              width: 2,
            }),
          }),
        };

        // @ts-ignore
        state.styleCachePharmacy[size] = new Style(params);
        return state.styleCachePharmacy[size];
      },
    });

    dispatch('map/addLayer', state.pharmaciesVectorLayer, {root: true});
  }
};

// @ts-ignore
export const setVisibility = ({state}, visibility) => {
  state.pharmaciesVectorLayer.setVisible(visibility);
};
